import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    event.preventDefault()
    event.stopPropagation()

    const url = event.currentTarget.href || event.params.url
    if (!url) return

    this._fetchAndShow(url)
  }

  close() {
    this._hideModal()
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalOverlay) {
      this._hideModal()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && this.modal) {
      this._hideModal()
    }
  }

  async _fetchAndShow(url) {
    const separator = url.includes("?") ? "&" : "?"
    const response = await fetch(`${url}${separator}modal=1`, {
      headers: { "Accept": "text/html" }
    })
    const html = await response.text()

    this._createModal(html)
  }

  _createModal(html) {
    // Remove existing modal if any
    this.modal?.remove()

    const wrapper = document.createElement("div")
    wrapper.innerHTML = `
      <div data-role="legal-modal"
           class="fixed inset-0 z-[60] flex items-center justify-center p-4"
           data-action="keydown.escape->legal-document#closeOnEscape click->legal-document#closeOnBackdrop">
        <div data-role="overlay"
             class="absolute inset-0 bg-black/60 backdrop-blur-sm overlay-hidden"></div>
        <div data-role="panel"
             class="relative bg-slate-800 rounded-xl border border-slate-700 shadow-xl
                    max-w-3xl w-full max-h-[85vh] overflow-y-auto panel-hidden">
          ${html}
        </div>
      </div>
    `

    this.modal = wrapper.firstElementChild
    this.modalOverlay = this.modal.querySelector("[data-role=overlay]")
    const panel = this.modal.querySelector("[data-role=panel]")

    document.body.appendChild(this.modal)
    document.body.classList.add("overflow-hidden")

    // Trigger enter animations
    requestAnimationFrame(() => {
      this.modalOverlay.classList.add("overlay-enter")
      this.modalOverlay.classList.remove("overlay-hidden")
      panel.classList.add("panel-enter")
      panel.classList.remove("panel-hidden")
    })

    // Wire up close button inside the fetched content
    this.modal.querySelectorAll("[data-action='legal-document#close']").forEach(btn => {
      btn.addEventListener("click", () => this._hideModal())
    })
  }

  _hideModal() {
    if (!this.modal) return

    const overlay = this.modal.querySelector("[data-role=overlay]")
    const panel = this.modal.querySelector("[data-role=panel]")

    overlay?.classList.remove("overlay-enter")
    overlay?.classList.add("overlay-hidden")
    panel?.classList.remove("panel-enter")
    panel?.classList.add("panel-hidden")

    const cleanup = () => {
      this.modal?.remove()
      this.modal = null
      this.modalOverlay = null
      document.body.classList.remove("overflow-hidden")
    }

    if (panel && !this.prefersReducedMotion) {
      panel.addEventListener("transitionend", cleanup, { once: true })
    } else {
      cleanup()
    }
  }

  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
